const locale = {
  blocker: {
    adult: {
      cta: "ฉันเป็นผู้ใหญ่",
      signInCta: "Sign In",
      subtitle: "This video contains adult content which is not appropriate for teenagers and kids.",
      title: "Adult and sensitive contents"
    },
    chrome_version: {
      subtitle: "Make sure you are using the latest version of Google Chrome.",
      title: "Please update your browser"
    },
    drm: {
      additional_cta: "More Info",
      cta: "Find Other Content",
      subtitle: "Your device doesn’t support DRM. Please use another device or browse other content.",
      title: "This content can’t be played"
    },
    fetching_error: {
      additional_cta: "Report Problem",
      cta: "Retry",
      subtitle: "Sit tight while we get things fixed and try again later.",
      title: "Oops, something went wrong"
    },
    general_error: {
      additional_cta: "Report Problem",
      cta: "Retry",
      subtitle: "Sit tight while we get things fixed and try again later.",
      title: "Oops, something went wrong"
    },
    geoblock: {
      additional_cta: "More Info",
      cta: "Explore Vidio",
      subtitle: "You can find many other things to enjoy on Vidio!",
      title: "Content not available in your country"
    },
    hdcp: {
      additional_cta: "More Info",
      cta: "Explore Vidio",
      subtitle: "Your device doesn’t support HDCP. Please use another device or browse other content.",
      title: "This content can't be played"
    },
    media_error: {
      additional_cta: "Error Details",
      cta: "Report Problem",
      subtitle: "Please try again with another device",
      title: "An error occurred while processing the media"
    },
    media_not_supported: {
      additional_cta: "Error Details",
      cta: "Report Problem",
      subtitle: "Please try again with another device.",
      title: "Problem with your device"
    },
    network_error: {
      additional_cta: "Error Details",
      cta: "Retry",
      subtitle: "There's a problem connecting to Vidio. Please try again later.",
      title: "Network error"
    },
    not_supported_browser: {
      additional_cta: "Report Problem",
      subtitle: "Please update your browser or download our apps.",
      title: "Your browser is not supported."
    },
    sign_in: {
      cta: "Sign In",
      description: "Sign in to watch this video"
    }
  },
  control_bar: {
    "Cinema Mode": "โหมดภาพยนตร์",
    Fullscreen: "แบบเต็มหน้าจอ",
    Mute: "ปิดเสียง",
    Next: "ต่อไป",
    "Non-Fullscreen": "ไม่ใช่แบบเต็มหน้าจอ",
    Pause: "หยุดชั่วคราว",
    Play: "เล่น",
    "Playback Settings": "การตั้งค่าการเล่น",
    Replay: "เล่นซ้ำ",
    "Seek backward 10 seconds": "ค้นหาย้อนกลับ 10 วินาที",
    "Seek forward 10 seconds": "ค้นหาไปข้างหน้า 10 วินาที",
    Unmute: "ยกเลิกการปิดเสียง"
  },
  settings_menu: {
    normal: "Normal",
    off: "Off",
    playback_speed: "Playback Speed",
    send_feedback: "Send Feedback",
    settings: "Settings",
    subtitle: "Subtitle",
    video_quality: "Video Quality"
  }
};
export default locale;
